<div class="container-fluid">
  <ng-container *ngIf="dataSource && dataSource.data.length > 0; else noDoc">
    <div>
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="icon">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="head-img">
            <a *ngIf="row.viewable;" (click)="viewDoc(row.doc)" (keyup)="viewDoc(row.doc)" aria-disabled="true"
              appTooltip="Visualiser le document"><ng-container
                *ngTemplateOutlet="iconContent;context:{data: row}"></ng-container></a>
            <ng-container *ngIf="!row.viewable">
              <ng-container *ngTemplateOutlet="iconContent;context:{data: row}"></ng-container>
            </ng-container>
          </td>
        </ng-container>
        <ng-template #iconContent let-row="data">
          <div class="d-flex">
            <mat-icon class="file-icon" [appTooltip]="row.iconTooltip" color="primary"><i
                [class]="row.icon"></i></mat-icon>
            <mat-icon appTooltip="Document certifié" *ngIf="row.certified" color="accent"
              class="small-icon">verified_user</mat-icon>
            <mat-icon [appTooltip]="row.docIdentifierName" *ngIf="row.docIdentifierName" color="accent"
              class="small-icon">info</mat-icon>
            <mat-icon appTooltip="Document récupéré automatiquement" *ngIf="!row.docIdentifierName && row.auto"
              color="accent" class="small-icon">cloud_done</mat-icon>
          </div>
        </ng-template>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Nom</th>
          <td mat-cell *matCellDef="let row" class="main">
            <a *ngIf="row.viewable" (click)="viewDoc(row.doc)" (keyup)="viewDoc(row.doc)" aria-disabled="true"
              appTooltip="Visualiser le document"><ng-container
                *ngTemplateOutlet="nameContent;context:{data: row}"></ng-container></a>
            <ng-container *ngIf="!row.viewable">
              <ng-container *ngTemplateOutlet="nameContent;context:{data: row}"></ng-container>
            </ng-container>
          </td>
        </ng-container>
        <ng-template #nameContent let-row="data">
          {{ row.name }}
        </ng-template>
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Type</th>
          <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.type }}</td>
        </ng-container>
        <ng-container matColumnDef="size">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Taille</th>
          <td mat-cell *matCellDef="let row" class="mobile-inline mobile-separator">{{ row.size | fileSize }}</td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
          <td mat-cell *matCellDef="let row">{{ row.date }}</td>
        </ng-container>
        <ng-container matColumnDef="description">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let row" class="no-mobile">{{ row.description }}</td>
        </ng-container>
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef>Actions</th>
          <td mat-cell *matCellDef="let row" class="mobile-double-actions">
            <button class="mobile-inline" mat-icon-button [style]="row.viewable ? '' : 'visibility: hidden'"
              (click)="viewDoc(row.doc)" appTooltip="Visualiser le document"><mat-icon
                color="primary">remove_red_eye</mat-icon></button>
            <a class="m-1" *ngIf="row.viewable && row.viewableInNewPage" [href]="row.url" target="_blank"
              appTooltip="Visualiser le document"><mat-icon color="primary">remove_red_eye</mat-icon></a>

            <button mat-icon-button [matMenuTriggerFor]="actions" [matMenuTriggerData]="{data:row}">
              <mat-icon>more_vert</mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </ng-container>
  <ng-template #noDoc>
    <span class="no-content dark">Aucun document n'est disponible dans cette catégorie</span>
  </ng-template>
</div>

<mat-menu #actions="matMenu">
  <ng-template matMenuContent let-row="data">
    <ul class="menu-actions">
      <li>
        <a [href]="row.url" [download]="row.filename"><mat-icon color="primary">cloud_download</mat-icon><span
            class="text">Télécharger le document</span></a>
      </li>
      <li *ngIf="row.canUpdate">
        <a (click)="edit(row.doc)"><mat-icon color="primary">create</mat-icon><span class="text">Modifier le
            document</span></a>
      </li>
      <li *ngIf="row.canUpdate">
        <a (click)="changeOrder(row.doc)"><mat-icon color="primary">low_priority</mat-icon><span class="text">Modifier
            la position</span></a>
      </li>
      <li *ngIf="row.canDelete">
        <a (click)="confirmDelete(row.doc)">
          <mat-icon color="primary">delete_forever</mat-icon>
          <span class="text">Supprimer le document</span>
        </a>
      </li>
    </ul>
  </ng-template>
</mat-menu>